<template>
  <div>
    <section class="pb-5 reviews-section">
      <div class="container">
        <div class="py-5">
          <h3 class="text-center py-4 fw-bold">Reviews</h3>
          <swiper
            :slidesPerView="1"
            :spaceBetween="25"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :pagination="{
              clickable: true,
            }"
            :navigation="true"
            :modules="modules"
          >
            <swiper-slide v-for="review in reviews" :key="review.id">
              <div class="testimony-card text-center">
                <p>
                  "I highly recommend Fhenix Africa's corporate training
                  programs to any company looking to upskill their team. The
                  trainers were professional, organized, and made the learning
                  experience enjoyable. The content was relevant and practical,
                  and our team was able to apply what they learned right away."
                </p>

                <div class="mt-5 d-flex justify-content-center align-items-center testifier-info">
                  <div class="d-flex gap-3 align-items-center ">
                    <img
                      :src="
                        require(`../../assets/Images/home/${review.image_src}`)
                      "
                      class="testifier"
                      alt=""
                    />
                    <div>
                        <h5 class="mb-1">Obot Ekanem</h5>
                        <p class="mb-0">CEO Obed Digital</p>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center text-center info-spread text-white">
         <div class="info-strip">
          <h5 class="mb-3">Join a community of successful graduates with our practical, hands-on training programs designed to give you the competitive edge needed for your tech career goals.</h5>
          <router-link to="/contact" class="btn btn-outline-light">
            Contact us
          </router-link>
         </div>
        </div>
    </section>
  </div>
</template>
    
    <script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import { Autoplay, Pagination, Navigation, EffectCoverflow } from "swiper";
export default {
  name: "Arduino",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      reviews: [
        {
          id: 1,
          review: "kompletecare-cover.png",
          name: "Obot Ekanem",
          title: "CEO Obed Digital",
          image_src: "review.png" 
        },
        {
          id: 2,
          review: "kompletecare-cover.png",
          name: "Obot Ekanem",
          title: "CEO Obed Digital",
          image_src: "review.png" 
        },
        {
          id: 3,
          review: "kompletecare-cover.png",
          name: "Obot Ekanem",
          title: "CEO Obed Digital",
          image_src: "review.png" 
        },
      
      ],
    };
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation, EffectCoverflow],
    };
  },
};
</script>
    
    <style scoped>
.products-section {
  background: #d8e2f3;
}
.learn-slider {
  width: 70% !important;
  margin: 0 auto;
}

.learn-image {
  height: 400px;
}

.product-img {
  height: 420px;
}

.testifier {
    height: 72px;
    width: 72px !important;
    border-radius: 50%;
}

.testimony-card {
    width:70%;
    margin: 0 auto;
}

.info-strip {
  width: 70%;
}

.info-spread {
  height: 380px;
  background: linear-gradient(45deg, #000000c7, #000000c9), url(../../assets/Images/house3.png) no-repeat;
  background-position: center;
  background-size: cover;
}

/* .testifier-info {
    width: 40%;
} */

/* .swiper-button-next,
  .swiper-button-prev {
    color: #ffffff;
    font-size: 30px;
    z-index: 900;
    color: blue !important;
  }
  
  .swiper-button-next {
    right: 0px;
  }
  
  .swiper-button-prev {
    left: 0px;
  } */

.showcase {
  height: 360px;
}

.swiper-container {
  width: 100%;
  height: 300px;
}

.swiper-slide {
  display: block;
}

.image-box {
  margin: 10px;
}

.swiper-slide img {
  display: block;
  width: 100%;
}

@media (max-width: 769px) {
  .testimony-card {
    width: 95%;
  }
}
</style>
    